import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    fbp: null,
    fbc: null
};


export const fbSlice = createSlice({
    name: 'fb',
    initialState,
    reducers: {
        getFacebookFbp: (state,action) => {
            const cookie = document.cookie.split("; ").find(row => row.startsWith("_fbp="));
            console.log("cookie", cookie, cookie ? cookie.split("=")[1] : null);
            
            state.fbp = cookie ? cookie.split("=")[1] : 0;
        },
        getFacebookFbc: (state,action) => {
            const cookie = document.cookie.split("; ").find(row => row.startsWith("_fbc="));
            console.log(action.payload);
            
            if (cookie){
                state.fbc = cookie.split("=")[1] | null;
            }else{
                // If `fbc` is not in cookies, check the URL
                const urlParams = new URLSearchParams(window.location.search);
                const fbcFromUrl = urlParams.get("fbclid");
                state.fbc = fbcFromUrl ? `fb.1.${Date.now()}.${fbcFromUrl}` : null;
            }  
        }
    },
});

export const { getFacebookFbp, getFacebookFbc } = fbSlice.actions;
export default fbSlice.reducer;
